import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Doctocat provides a collection of React components that are globally available in all `}<inlineCode parentName="p">{`.md`}</inlineCode>{` and `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` files (no import required).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      